import React from 'react'
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
  } from "recharts";
 
const data = [
    {
      name: 'Jan',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'Feb',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: 'Mar',
      uv: 5000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: 'Apr',
      uv: 4780,
      pv: 1908,
      amt: 2000,
    },
    {
      name: 'May',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: 'Jun',
      uv: 5390,
      pv: 6800,
      amt: 2500,
    },
    {
      name: 'Jul',
      uv: 6490,
      pv: 2300,
      amt: 2100,
    },
    {
      name: 'Aug',
      uv: 1490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: 'Sep',
      uv: 2490,
      pv: 6300,
      amt: 2100,
    },
    {
      name: 'Oct',
      uv: 5490,
      pv: 1300,
      amt: 2100,
    },
    {
      name: 'Nov',
      uv: 1490,
      pv: 2300,
      amt: 2100,
    },
    {
      name: 'Dec',
      uv: 2000,
      pv: 6300,
      amt: 2100,
    },
  ]

const TwoLineChart = () => {
  return (
    <span>
    <ResponsiveContainer height={200}>
      <LineChart
        width={500}
        height={100}
        data={data}
        syncId="anyId"
        margin={{
          top: 0,
          left: 30,
          right: 30,
          bottom: 0,
        }}
      >
        <XAxis dataKey="name" style={{ fontSize: "10" }} />
        <YAxis style={{ fontSize: "10" }} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="pv"
          stroke="#3FD600"
          strokeWidth={2}
          fill="#527DFF"
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="uv"
          stroke="#527DFF"
          strokeWidth={2}
          fill="#527DFF"
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  </span>
  )
}

export default TwoLineChart